<template>
    <section
        class="relative bg-gradient-to-t from-transparent via-accent/10 via-25% to-transparent">
        <div class="container flex items-center justify-between">
            <AtomTitle> {{ title }} </AtomTitle>
            <div class="hidden space-x-3 md:flex">
                <ArrowButton
                    id="equipment-prev"
                    aria-label="Предыдущее оборудование"
                    class="rotate-180" />
                <ArrowButton
                    id="equipment-next"
                    aria-label="Следующее оборудование" />
            </div>
        </div>
        <div class="container">
            <div
                ref="sliderElement"
                class="swiper swiper-equipment"
                :class="isCromi() ? '!pr-5' : ''">
                <div class="swiper-wrapper mt-5 md:mt-10 md:items-stretch">
                    <div
                        v-for="product in items"
                        :key="product.slug"
                        class="swiper-slide !h-auto max-md:!w-[17.5rem]">
                        <div class="swiper-slide__inner h-full">
                            <ProductCard :product />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="showCatalogButton && directionSlug"
            class="mt-10 text-center md:mt-20">
            <BaseLink
                :to="`/catalog/#${directionSlug}`"
                icon-right="arrow-right"
                size="accent">
                Перейти к каталогу
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import type {
    TCromiRentDirectionSlug,
    TDirectionSlug,
} from '~/types/global.types'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import ArrowButton from '~/components/base/arrow-button/ArrowButton.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import ProductCard from '~/components/particles/product-card/ProductCard.vue'
import type { IProductCard } from '~/components/particles/product-card/product-card.types'

defineProps({
    items: {
        type: Array as PropType<IProductCard[]>,
        default: () => [],
    },
    title: {
        type: String as PropType<string>,
        default: 'Подробнее об оборудовании',
    },
    directionSlug: {
        type: [String, null] as PropType<
            TDirectionSlug | TCromiRentDirectionSlug | null
        >,
        default: null,
    },
    showCatalogButton: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const sliderElement = ref<HTMLElement | null>(null)
let slider: Swiper | null = null

onMounted(() => {
    if (!sliderElement.value) return

    slider = new Swiper(sliderElement.value, {
        modules: [Navigation],
        navigation: {
            prevEl: '#equipment-prev',
            nextEl: '#equipment-next',
        },
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            320: {
                spaceBetween: 8,
            },
            375: {
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    })
})

onBeforeUnmount(() => {
    slider?.destroy()
})
</script>
